import gettersMethods from './getters';
import mutationsMethods from './mutations';
import actionsMethods from './actions';

export default {
   namespaced : true,

   state() {
      return {
         hasNotification: true,
         hasSoundEffect: 'off',
      }
   },

   getters: gettersMethods,
   mutations: mutationsMethods,
   actions: actionsMethods,
};
